import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';

@Component({
  selector: 'app-search-exam-sub',
  templateUrl: './search-exam-sub.component.html',
  styleUrls: ['./search-exam-sub.component.scss']
})
export class SearchExamSubComponent implements OnInit {
  APIService: string;
  subGrid: any;

  constructor(
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,   public router: Router,  private httpClient: HttpClient,
   private spinner: NgxSpinnerService,
   private dialogRef2:MatDialogRef<SearchExamSubComponent>,
   private dialog: MatDialog,
     ) { this.APIService = environment.serviceUrl; }

  ngOnInit(): void {
    this.SubData(this.data)
  }

  SubData(data){

    this.subGrid = []
    this.spinner.show();
    const payload = {};
    payload['FsEfId'] = data.EfId
    this.umsService.SearchExamSub(payload).subscribe((res) => {
      this.spinner.hide();
      this.subGrid = res.data;
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.subGrid = []
    })
  }


  download(){
    var filter: any;
    const payload1 = {};
    payload1['FsEfId'] = this.data.EfId;
    let jsonString = JSON.stringify(payload1).replace(/\\/g, '');
    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 503,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId": '',//this.emid
      "CsNo": '',
      "PgBreak": '',
      "StrId": '', //this.submitpayload['strId'] ? this.submitpayload['strId'] : 0,
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": '',
      "Extra1": JSON.stringify(payload1),
    }
    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }

  redirect(to): void {
    this.router.navigate([to]);
  }
}
